import { render, staticRenderFns } from "./AndroidHealthOverview.vue?vue&type=template&id=524fbac0&scoped=true"
import script from "./AndroidHealthOverview.vue?vue&type=script&lang=js"
export * from "./AndroidHealthOverview.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthOverview.vue?vue&type=style&index=0&id=524fbac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524fbac0",
  null
  
)

export default component.exports